module.exports = __webpack_public_path__ + "img/ft2501.695c7115.jpg";